import CallIcon from '../assets/icons/callicon';
import EmailIcon from '../assets/icons/emailIcon';
import FaceBookIcon from '../assets/icons/facebookIcon';
import InstaIcon from '../assets/icons/InstaIcon';
import LinkedinIcon from '../assets/icons/linkedin';
import { BackImage, footerLogo } from '../assets/images';
import { Link, useLocation } from 'react-router-dom';
import DashedBorder from '../assets/icons/border';

const Footer = () => {
	const menuItems = [
		{ name: 'Home', path: '/' },
		{ name: 'About Us', path: '/about' },
		{ name: 'Products', path: '/products' },
		{ name: 'Contact Us', path: '/contact' },
	];
	const location = useLocation();
	return (
		<footer
			className="w-full bg-center bg-no-repeat items-center xl:h-[788px] lg:h-[788px] md:h-[950px] sm:h-[950px] h-[950px] flex flex-col"
			style={{
				backgroundImage: `url(${BackImage})`,
				backgroundSize: 'auto',
				backgroundPosition: 'center bottom',
			}}
		>
			<div
				className="xl:w-[454px] lg:w-[454px] md:w-[454px] sm:w-[225px] w-[225px] h-[48px] xl:h-[72px] lg:h-[72px] md:h-[50px] sm:h-[48px]
               bg-white rounded-[28px] 
               shadow-[0px_4px_20px_0px_#0000000F] opacity-100 xl:mt-[100px] lg:mt-[100px] md:mt-[60px] sm:mt-[60px] mt-[60px] relative"
			>
				<DashedBorder
					radiusDesktop={28}
					radiusMobile={26}
				/>
			</div>
			<div className="flex flex-col xl:flex-row lg:flex-row md:flex-col items-start xl:w-[1200px] lg:w-[900px] md:w-[680px] sm:w-[425px] ms:w-full xs:w-full pt-[60px] xl:pt-[150px] lg:pt-[150px]  sm:pt-[60px] xl:gap-[81px] lg:gap-[50px] xl:px-0 lg:px-0 md:px-0 sm:px-[20px] px-[20px]">
				<div className="flex flex-col gap-2 flex-shrink-0">
					<img src={footerLogo} height={"58px"} width={"161px"} className='sm:w-[108px] sm:h-[40px]' alt='logo'/>
					<p className="font-plusJakarta xl:text-[16px] lg:text-[16px] md:text-[14px] sm:text-[14px] text-[14px] font-[400] text-black leading-[150%] tracking-[0%]">
						Believe. Behave. Become.
					</p>
				</div>
				<div className="hidden lg:flex xl:gap-[78px] lg:gap-[30px] flex-1">
					<div className="flex xl:gap-[81px] lg:gap-10 md:gap-5">
						<div className="flex flex-col gap-5 xl:w-[86px] lg:w-[80px]">
							{menuItems.map((item, index) => {
								const isActive =
									location.pathname === item.path;

								return (
									<Link
										key={index}
										to={item.path}
										className={`xl:text-[16px] lg:text-[14px] md:text-[12px] leading-[100%] tracking-[0] text-black
                                        ${
											isActive
												? 'font-google font-medium underline decoration-solid decoration-[0.5px] decoration-skip-ink-auto'
												: 'font-plusJakarta font-normal no-underline'
										}`}
									>
										{item.name}
									</Link>
								);
							})}
						</div>
						<div className="flex flex-col gap-[21px] xl:w-[244px] lg:w-[180px]">
							<h3 className="font-plusJakarta font-bold xl:text-[16px] lg:text-[14px] md:text-[14px] leading-[100%] tracking-[0] text-black">
								Unit Address
							</h3>
							<p className="font-normal xl:text-[16px] lg:text-[14px] md:text-[14px] leading-[24px] tracking-[0] text-black font-plusJakarta">
								Zecca Pac, Vill. veravar shapar, plot no. 3,
								subplot no. 3/2, kotda
								sangani, Shapar, Rajkot, Gujarat, <br /> India - 360026.
							</p>
						</div>
					</div>
					<div className="flex xl:gap-20 lg:gap-8 md:gap-5">
						<div className="flex flex-col gap-[21px] xl:w-[164px] lg:w-[140px]">
							<h3 className="font-plusJakarta font-bold xl:text-[16px] lg:text-[14px] md:text-[14px] leading-[100%] tracking-[0] text-black">
								Office Address
							</h3>
							<p className="font-normal xl:text-[16px] lg:text-[14px] md:text-[14px] leading-[24px] tracking-[0] text-black font-plusJakarta">
								E/2/11, Aalap Avenue, University Road, Rajkot, Gujarat, 
								<br/>
								India - 360 005.
							</p>
						</div>
						<div className="flex flex-col gap-4">
							<h3 className="font-plusJakarta font-bold xl:text-[16px] lg:text-[14px] md:text-[14px] leading-[100%] tracking-[0] text-black">
								Contact Info
							</h3>
							<a
								href="tel:+9199090 09023"
								className="flex items-center gap-2 hover:opacity-80 transition-opacity duration-200"
							>
								<CallIcon />
								<p className="font-plusJakarta font-normal xl:text-[16px] lg:text-[14px] md:text-[14px] leading-[24px] tracking-[0] text-black">
									+91 99090 09023
								</p>
							</a>
							<a
								href="mailto:contact@zecca.in"
								className="flex items-center gap-2 hover:opacity-80 transition-opacity duration-200"
							>
								<EmailIcon />
								<p className="font-plusJakarta font-normal xl:text-[16px] lg:text-[14px] md:text-[14px] leading-[24px] tracking-[0] text-black">
									contact@zecca.in
								</p>
							</a>
						</div>
					</div>
				</div>
				<div className="md:flex lg:hidden flex-1 flex-col w-full">
					<div className="flex justify-between mt-[40px]">
						<div className="flex flex-col gap-3">
							{menuItems.map((item, index) => {
								const isActive =
									location.pathname === item.path;

								return (
									<Link
										key={index}
										to={item.path}
										className={`leading-[100%] tracking-[0] text-black text-[14px]
                                        ${
											isActive
												? 'font-google font-medium underline decoration-solid decoration-[0.5px] decoration-skip-ink-auto'
												: 'font-plusJakarta font-normal no-underline'
										}`}
									>
										{item.name}
									</Link>
								);
							})}
						</div>
						<div className="flex flex-col gap-2">
							<h3 className="font-plusJakarta font-bold  leading-[100%] tracking-[0] text-black text-[14px]">
								Contact Info
							</h3>
							<a
								href="tel:+9199090 09023"
								className="flex items-center gap-2 hover:opacity-80 transition-opacity duration-200"
							>
								<CallIcon />
								<p className="font-plusJakarta font-normal  leading-[24px] tracking-[0] text-black text-[14px]">
									+91 99090 09023
								</p>
							</a>
							<a
								href="mailto:contact@zecca.in"
								className="flex items-center gap-2 hover:opacity-80 transition-opacity duration-200"
							>
								<EmailIcon />
								<p className="font-plusJakarta font-normal  leading-[24px] tracking-[0] text-black text-[14px]">
									contact@zecca.in
								</p>
							</a>
						</div>
					</div>
					<div className="flex flex-col gap-2 pt-10">
						<h3 className="font-plusJakarta font-bold text-[14px] leading-[100%] tracking-[0] text-black">
							Unit Address
						</h3>
						<p className="font-plusJakarta font-normal text-[14px] leading-[24px] tracking-[0] text-black">
							Zecca Pac, Vill. veravar shapar, plot no. 3, subplot
							no. 3/2, radhe industrial zone, kotda sangani,
							Shapar, Rajkot, Gujarat 360026.
						</p>
					</div>
					<div className="flex flex-col gap-2 sm:pt-[40px] ms:pt-[40px] xs:pt-[40px]">
						<h3 className="font-plusJakarta font-bold text-[14px] leading-[100%] tracking-[0] text-black">
							Office Address
						</h3>
						<p className="font-plusJakarta font-normal text-[14px] leading-[24px] tracking-[0] text-black">
							E/2/11, Aalap Avenue, University Road, Rajkot - 360
							005.
						</p>
					</div>
				</div>
			</div>
			<hr className="border border-[#FFFFFF] xl:w-[1200px] lg:w-[900px] md:w-[680px] sm:w-[393px] ms:w-full xs:w-full xl:my-8 lg:my-8 md:my-8 sm:my-12 my-12 rounded-full" />
			<div className="flex flex-col sm:flex-row justify-between xl:items-center lg:items-center md:items-center sm:items-start items-start xl:w-[1200px] lg:w-[900px] md:w-[680px] sm:w-[425px] ms:w-full xs:w-full gap-4 xl:px-0 lg:px-0 md:px-0 sm:px-[20px] px-[20px]">
				<p className="font-plusJakarta font-medium text-[14px] leading-[150%] tracking-[0] text-black xl:text-center lg:text-center md:text-center text-left sm:text-left">
					Copyrights © 2023 all rights reserved by Zecca Incorporation
				</p>

				<div className="flex items-center gap-[10px] w-[125px] h-[35px]">
					<a
						href="https://www.facebook.com/zecca.pac?mibextid=ZbWKwL" 
						target="_blank"
						rel="noopener noreferrer"
						className="bg-white w-[35px] h-full rounded-[200px] shadow-[0_4px_20px_0_#00000014] flex items-center justify-center opacity-100 transition-all duration-300"
					>
						<FaceBookIcon />
					</a>

					<a
						href="https://www.instagram.com/zecca.pac?igsh=MWdqZHA5aDF1aGE3Mg=="
						target="_blank"
						rel="noopener noreferrer"
						className="bg-white w-[35px] h-full rounded-[200px] shadow-[0_4px_20px_0_#00000014] flex items-center justify-center opacity-100 transition-all duration-300"
					>
						<InstaIcon />
					</a>

					<a
						href="https://www.linkedin.com/company/zecca-pac/"
						target="_blank"
						rel="noopener noreferrer"
						className="bg-white w-[35px] h-full rounded-[200px] shadow-[0_4px_20px_0_#00000014] flex items-center justify-center opacity-100 transition-all duration-300"
					>
						<LinkedinIcon />
					</a>
				</div>
			</div>
		</footer>
	);
};

export default Footer;
